export const formatNamesForFile = (data: any) => {
  if (!data) return "NoNames"

  if (Array.isArray(data)) {
    const names = data.map((item) => item.name).filter(Boolean)
    if (names.length === 0) return "NoNames"
    if (names.length <= 2) return names.join(", ")
    return `${names.slice(0, 2).join(", ")} +${names.length - 2}`
  }

  return data.name || "NoNames"
}
